export const TEST_TYPE_FILTERS = [
  { label: "All types", value: "all" },
  { label: "CRIU", value: "criu" },
  { label: "Cryod (K8s)", value: "cryod" },
] as const;

// --- Cryod Runs Overview (pivot/breakdown explorer) ---

// Fixed breakdown dimensions. The page appends facet-discovered extra-tag keys
// (mapped to `extra:<key>`) to this list at render time, so new YAML tags become
// group-by/filter options with no frontend deploy.
export const CRYOD_FIXED_DIMENSIONS = [
  { label: "Model", value: "model_id" },
  { label: "Tensor parallel", value: "tensor_parallel" },
  { label: "Data parallel", value: "data_parallel" },
  { label: "Expert parallel", value: "expert_parallel" },
  { label: "Quantization", value: "quantization" },
  { label: "NVIDIA driver", value: "nvidia_driver_version" },
  { label: "Engine version", value: "engine_version" },
  { label: "Deploy version", value: "version" },
  { label: "Storage engine", value: "storage_engine_enabled" },
  { label: "GPU type", value: "gpu_type" },
  { label: "Operation", value: "operation" },
  { label: "Test", value: "test_name" },
] as const;

// Reliability + restore-latency + transfer/size metrics (the chosen set).
export const CRYOD_METRICS = [
  { label: "Restore time (total)", value: "total_restore_ms", unit: "ms" },
  { label: "CRIU restore", value: "criu_restore_ms", unit: "ms" },
  { label: "HTTP ready", value: "http_ready_ms", unit: "ms" },
  { label: "Cold start", value: "cold_start_ms", unit: "ms" },
  { label: "Mooncake transfer", value: "mooncake_transfer_ms", unit: "ms" },
  { label: "Checkpoint size", value: "checkpoint_size_bytes", unit: "bytes" },
  { label: "Checkpoint weights", value: "checkpoint_weights_bytes", unit: "bytes" },
] as const;

export const CRYOD_AGGS = [
  { label: "p50", value: "p50" },
  { label: "p95", value: "p95" },
  { label: "mean", value: "mean" },
] as const;

export const CRYOD_WINDOWS = [
  { label: "7d", value: "7d" },
  { label: "30d", value: "30d" },
  { label: "90d", value: "90d" },
] as const;

// Human label for a dimension key (fixed or `extra:<key>`).
export function cryodDimensionLabel(dimension: string): string {
  const fixed = CRYOD_FIXED_DIMENSIONS.find((entry) => entry.value === dimension);
  if (fixed) return fixed.label;
  if (dimension.startsWith("extra:")) return dimension.slice("extra:".length);
  return dimension;
}

// Render a stringified group value for display, dimension-aware.
export function cryodValueLabel(dimension: string, value: string): string {
  if (!value) return "unknown";
  if (dimension === "storage_engine_enabled") return value === "1" ? "mooncake" : "hostPath";
  if (dimension === "expert_parallel") return value === "true" ? "EP on" : "EP off";
  return value;
}
